module.exports = __webpack_public_path__ + "static/media/gabriela.4412f735.jpg";